import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Spinner,
  Alert,
  Switch,
} from '@chakra-ui/react';
import axios from 'axios';
import { API_URL } from "../../constants";
import { getAuthToken } from "../../helpers/helpers";

export default function QuickSellConfig() {
  const [allowQuickSell, setAllowQuickSell] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${API_URL}/api/points-config`, {
        headers: {
          'x-access-token': token,
          'Authorization': `Bearer ${token}`
        }
      });
      const data = response.data;
      setAllowQuickSell(data.allowQuickSell === undefined ? true : data.allowQuickSell);
    } catch (error) {
      setErrorMessage("Erreur lors du chargement de la configuration");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const token = getAuthToken();
      await axios.put(`${API_URL}/api/points-config`, {
        allowQuickSell: !!allowQuickSell
      }, {
        headers: {
          'x-access-token': token,
          'Authorization': `Bearer ${token}`
        }
      });
      setSuccessMessage("Configuration mise à jour avec succès");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      setErrorMessage("Erreur lors de la mise à jour de la configuration");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Box mt="64px" textAlign="center"><Spinner size="xl" /></Box>;

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Box px={4} w="100%" maxW="800px" mx="auto">
        <Text fontSize="2xl" fontWeight="bold" mb={6}>Vente depuis Recherche Rapide</Text>
        <Box p={6} borderWidth={1} borderRadius="xl" boxShadow="lg" bg="white">
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              {successMessage && (
                <Alert status="success" bg="green.500" color="white" borderRadius="md">
                  {successMessage}
                </Alert>
              )}
              {errorMessage && (
                <Alert status="error" bg="red.500" color="white" borderRadius="md">
                  {errorMessage}
                </Alert>
              )}
              <FormControl display="flex" alignItems="center">
                <FormLabel mb="0">Autoriser la vente depuis la Recherche Rapide</FormLabel>
                <Switch isChecked={allowQuickSell} onChange={(e) => setAllowQuickSell(e.target.checked)} />
              </FormControl>
              <Button
                colorScheme="brand"
                bg="#0D6B62"
                color="white"
                _hover={{ bg: "#0B5D55" }}
                isLoading={saving}
                type="submit"
                mt={4}
              >
                Enregistrer
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
